module.exports = __webpack_public_path__ + "static/img/logo.78e8414.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 1